__turbopack_context__.v({
  "modal-button": "modal-printer-comparison-module-scss-module__l3q0Qa__modal-button",
  "modal-button-base": "modal-printer-comparison-module-scss-module__l3q0Qa__modal-button-base",
  "modalAction": "modal-printer-comparison-module-scss-module__l3q0Qa__modalAction",
  "modalText": "modal-printer-comparison-module-scss-module__l3q0Qa__modalText",
});
